<template>
	<form @submit.prevent="onSubmit" :class="{ 
		'login': true, 
		'success': isSuccess, 
		'error': isError 
	}">
		<HermesLogo class="logo"/>
		<div class="message">
			<p>{{ message }}</p>
		</div>
		<TextInput center v-model:text="email" :disabled="isLoading" placeholder="Netfang"/>
		<TextInput center password v-model:text="password" :disabled="isLoading" placeholder="Lykilorð"/>
		<div>
			<button :disabled="!isValid">
				Skrá inn
			</button>
		</div>
	</form>
	<Loader :value="isLoading"/>
</template>

<script lang="ts">
import useNetlifyLogin from '#/useNetlifyLogin'

import { defineComponent, ref, computed } from 'vue'
import { isEmpty } from 'ramda'
import { useRoute, useRouter } from 'vue-router'
import { isOK } from '@/modules/OkFail'
import { delay } from '@/modules/Geri'

import HermesLogo from '@/components/gui/HermesLogo.vue'
import Loader     from '@/components/gui/Loader.vue'
import TextInput  from '@/components/gui/TextInput.vue'

export default defineComponent({
	name: 'LoginForm',

	components: {
		HermesLogo,
		Loader,
		TextInput
	},

	setup (props, { emit }) {
		const { login, authorize, isAuthorized } = useNetlifyLogin()
		const { hash } = useRoute()
		
		const email     = ref<string>('')
		const password  = ref<string>('')
		const isValid   = computed<boolean>(() => !isEmpty(email.value) && !isEmpty(password.value))
		const isSuccess = ref<boolean>(false)
		const isError   = ref<boolean>(false)
		const isLoading = ref<boolean>(false)
		const message   = ref<string>('')

		async function onSubmit (): Promise<void> {
			isLoading.value = true
			isSuccess.value = false
			isError.value   = false
			message.value   = ''
			
			const load = await login(email.value, password.value)
			
			if (isOK(load)) {
				isSuccess.value = true
				message.value   = 'Innskráning tókst!'

				authorize(email.value)
				await delay(500)
			}
			else {
				isError.value = true
				message.value = load.data?.json?.error_description ?? '?!?'
			}
			emit('login', isAuthorized())
			isLoading.value = false
		}

		return { 
			email, 
			password, 
			isValid, 
			onSubmit,
			isSuccess,
			isError,
			isLoading,
			message
		}
	}
})
</script>

<style lang="scss">
.login {
	text-align: center;
	max-width: 300px;

	.logo {
		margin: 24px auto 12px;
	}
	.message {
		padding: 12px;
		font-weight: 800;
	}
	.text-input {

	}
	button {
		margin-top: 18px;
		padding: 12px;
		font-size: 1.2rem;
		text-transform: uppercase;
		font-weight: 800;
		background: brown;
		border: none;
		color: #fff;
		box-shadow: 1px 1px 15px rgba(33, 33, 33, .3);

		&:hover {
			background: darken(brown, 10%);
			cursor: pointer;
		}
		&:disabled {
			background: gray;

			&:hover {
				cursor: not-allowed;
			}
		}
	}
	&.success {
		.message {
			color: greenyellow;
		}
	}
	&.error {
		.message {
			color: red;
		}
		input {
			border: 1px solid red;
		}
	}
}
</style>